import AcceptResourcesContainer from './AcceptResources.container';
export default AcceptResourcesContainer;
